<div class="file-upload" [class.pointers]="allowPointerEvents" [class.file-upload--dragover]="dragOver"
     (dragleave)="onDragLeave($event)"
     (dragover)="onDragOver($event)"
     (drop)="onDrop($event)">
  <div class="file-upload-border">
    <div class="file-upload-border-inner">
      <div class="header">
        <mat-icon class="upload-icon" svgIcon="k12-upload-regular"></mat-icon>
        <p class="title">{{ vm.dropFilesHereText }}</p>
        @if ((configJson?.inputs?.[0]?.['fileType']?.length ?? 0) > 0) {
            <p class="subtitle">
              Supported formats:
              @for (type of configJson?.inputs?.[0]?.['fileType']; track type; let last = $last) {
                {{ type }}@if (!last) {,}
              }
            </p>
        }
        <p class="instructions">- or -</p>
        <button class="browse-for-file" color="primary"
                data-qa="browse-for-file-button"
                data-pw="document-upload-button"
                mat-stroked-button
                [disabled]="!isEnabled"
                (click)="fileInput.click()">
          Browse for file
        </button>
        <input #fileInput class="input-file" data-pw="document-file-input"
               multiple type="file"
               [accept]="vm.supportedFileTypes()"
               [attr.id]="'document-file-input'"
               [disabled]="!isEnabled"
               (change)="onSelectedFile($event)"/>
      </div>
    </div>
    <div class="size-meter-wrapper">
      <lib-cfi-file-size-meter
        [usedBytes]="vm.totalSize()"
        [maxBytes]="getMaxFileSizeBytes()">
      </lib-cfi-file-size-meter>
    </div>
  </div>

  @if (rejectedFileMessage()) {
    <div class="rejected-files-message" data-qa="rejected-files-message">
      <mat-icon class="warning-icon" svgIcon="k12-warning"></mat-icon>
      <p>{{ rejectedFileMessage() }}</p>
    </div>
  }

  @if (configJson?.inputs?.[0] && vm.files().length > 0 || enrollmentBuilderView) {
    <div class="uploaded-files-container">
      @if (enrollmentBuilderView) {
        <div class="file-item-box layout">
          <div class="file-item-box-details">
            <p class="file-name">File name</p>
            <p class="file-size">
              File 0 of {{ configJson?.inputs?.[0]?.max ?? 0 }} (0mb of 0mb)
            </p>
          </div>
          @if (showUploadProgress) {
            <lib-cfi-file-size-meter [usedBytes]="0" [maxBytes]="0"></lib-cfi-file-size-meter>
          }
        </div>
      } @else {
        @for (file of vm.files(); track file.name; let i = $index) {
          <div class="file-item-box">
              <div class="file-item-box-details">
                <p class="file-name">{{ file?.name ?? 'File name' }}</p>
                @if (file?.size) {
                  <p class="file-size" [class.text-500]="uploadStatus(file) === 'failed'">
                    {{ formatFileSize(file.size) }}mb of {{ configJson?.inputs?.[0]?.fileSize ?? 0 }}mb
                  </p>
                }
                @if (uploadStatus(file) === 'uploading') {
                  <p class="file-message">Uploading...</p>
                }
                @if (uploadStatus(file) === 'failed') {
                  <p class="file-message error">Upload failed</p>
                }
                @if (uploadStatus(file) === 'succeeded') {
                  <p class="file-message success">File uploaded successfully</p>
                }
              </div>

              @if (uploadStatus(file) === 'failed') {
                <button data-qa="retry-upload" mat-icon-button matTooltip="Retry upload" (click)="retryUpload(file)">
                  <mat-icon class="retry-icon" svgIcon="k12-retry"></mat-icon>
                </button>
              }
              @if (uploadStatus(file) === 'succeeded') {
                <button class="success-view" data-qa="view-upload" type="button" (click)="viewUpload(file)">
                  View
                </button>
              }
              <button class="remove-file-button" data-qa="close-prompt-button" mat-icon-button
                      matTooltip="Remove file" (click)="onRemoveTemplatingFile(file)">
                <mat-icon svgIcon="k12-x-mark"></mat-icon>
              </button>
          </div>
        }
        @if (showUploadProgress) {
          @if (isUploading) {
            <div class="progress-bar-container">
              <mat-progress-bar class="upload-bar" mode="determinate"
                                [value]="currentUploadProgress"></mat-progress-bar>
              <p class="status">Uploading... {{ currentUploadProgress }}%</p>
            </div>
          } @else {
            <p class="ready-to-upload-status" data-qa="ready-to-upload-status">Ready to upload</p>
          }
        }
      }
    </div>
  }
</div>
